var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeacher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DFA539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffa600"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "url(#gradient)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 34,
    height: 26,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,16 h20 M15,22 h20 M15,28 h12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 37,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,30 v-5 M33,31 l-3,-4 M39,31 l3,-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,37 l2,-2 l2,1 l-1,-2 l2,-2 h-3 l-1,-2 l-1,2 h-3 l2,2 l-1,2 l2,-1 z",
    fill: "url(#gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,42 l13,-8 l13,8 l-13,8 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,42 v-7 M12,42 v-8 M25,34 v16"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.caa96c5eef5f6967077bf27170aea512.svg";
export { ForwardRef as ReactComponent };